import { BrowserRouter, Route, Routes } from "react-router-dom";
import AgendatePrivateZone from "./AgendatePrivateZone";
import AgendatePublicZone from "./AgendatePublicZone";
import { LoadingProvider, useLoading } from "./context/LoadingContext";
import { Cargando } from "./Componentes/LoaderComponent/cargando";
import AgendateInfoCita from "./AgendateInfoCita";

const AppContent = () => {
    const { cargando } = useLoading();

    return (
        <>
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<AgendatePublicZone />}></Route>
                    <Route path="zona-agendate" element={<AgendatePublicZone />} />
                    <Route path="zona-trx" element={<AgendatePrivateZone />} />
                    <Route path="zona-confirmacion-cita" element={<AgendateInfoCita />} />
                </Routes>
            </BrowserRouter>
            {cargando && <Cargando />}
        </>
    );
}

export const AgendateApp = () => {
    return (
        <LoadingProvider>
            <AppContent />
        </LoadingProvider>
    );
}
